export default __webpack_public_path__ + "static/media/timelapse.e1674901.gif";